import { gql } from 'graphql-tag';

export const ImageFragments = {
  imageFields: gql`
    fragment ImageFields on Image {
      width
      height
      url
    }
  `,
  displayIconFields: gql`
    fragment FishingWaterDetailDisplayIconFields on Image {
      width: width
      height: height
      url
    }
  `,
};
